import React from "react"
import types from "prop-types"
import { ProfileIcon } from "shared/icons"

const UserInfo = ({
  children = null,
  user = null,
}) => {
  if (!user) {
    user = { fullName: "No User" }
  }

  const userDisplayName = user.fullName

  return (
    <div className="flex-grow flex gap-3 items-center">
      <ProfileIcon user={user} className="w-8 h-8" />
      <div className="flex-grow">{userDisplayName}</div>
      { children }
    </div>
  )
}

UserInfo.propTypes = {
  children: types.node,
  user: types.shape({
    fullName: types.string,
  }),
}

export default UserInfo
